import { Bucket } from '../bucket';

export class BucketContext {
    bucket: Bucket;
    attributeIds: number[];
    overwrite: boolean;
}
